function _wrap_fn_(template_name, compiled, ext_path, theme_path, Handlebars) {
				var t = compiled;
				var main = t.main;
				t.main = function () {
					arguments[1] = arguments[1] || {};
					var ctx = arguments[1];
					ctx._extension_path = ext_path;
					ctx._theme_path = theme_path;
					return main.apply(this, arguments);
				};
				var template = Handlebars.template(t);
				template.Name = template_name;
				return template;
			}